import React from 'react';
import { ChevronDown, ChevronUp, X } from 'lucide-react';

export default function Accordion({ title, children, remove_accordion, accordion_id, accordion_no, handle_accordion, open_accordions }) {

  return (
    <>
      <div className="docpro_accordian">
        <div
          className="docpro_accordian_head"
          aria-expanded={open_accordions.includes(accordion_no)}
          onClick={() => handle_accordion(accordion_no)}
        >
          <span className="docpro_accordian_toggle">
            {open_accordions.includes(accordion_no)?
              <ChevronUp />
            :
              <ChevronDown />
            }
          </span>
          {title}
        </div>
        <button className="docpro_close" type='button' onClick={()=>remove_accordion(accordion_id)}>
          <X height={20} width={20} />
        </button>
        {open_accordions.includes(accordion_no) && <div className="docpro_accordian_body">{children}</div>}
      </div>
    </>
  );
}
